//React、hooks
import React, { useEffect, useState } from "react";
//css
import "../../css/Register.css";

import { useDispatch, useSelector } from "react-redux";
import { errorMsg, registerJudge, fetchAsyncRegister } from "./RegisterSlice";
import { useHistory } from "react-router-dom";

const Register: React.FC = () => {
  //パスワードはコンポーネント内でのみ管理
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [word, setWord] = useState("");
  const [userId, setUserId] = useState("");
  //エラーメッセージ
  const errorMessage = useSelector(errorMsg);
  //ログイン成功判定
  const registerJudgement = useSelector(registerJudge);
  //reducerにアクセス
  const dispatch = useDispatch();
  //リダイレクト用
  const navigate = useHistory();
  //ログイン成功？
  useEffect(() => {
    if (registerJudgement) {
      navigate.push("/login");
    }
  }, [registerJudgement, navigate]);

  //ログインフォーム送信関数
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      fetchAsyncRegister({
        user_id: userId,
        password: password,
        name: name,
        word: word,
      })
    );
  };
  return (
    <>
      <div className="login_container">
        <form className="login_form">
          <div className="login_title_container">
            <h1 className="login_title">Su__i 管理者画面　新規登録</h1>
          </div>

          <div className="login_input_container">
            {errorMessage && (
              <div className="error_msg">{errorMessage.toString()}</div>
            )}
            <input
              className="login_name_item"
              type="name"
              placeholder="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              className="login_id_item"
              type="id"
              placeholder="user_id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
            <input
              className="login_password_item"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <input
              className="login_word_item"
              type="text"
              placeholder="Word"
              value={word}
              onChange={(e) => setWord(e.target.value)}
            />
          </div>
          <div className="login_submit_button_container">
            <button className="login_submit_button" onClick={handleSubmit}>
              Register
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
export default Register;
